import ExploreFundsActions from "@redux/feature/Markets/MutualFunds/actions/exploreFunds";
import MutualFundsSchemesActions from "@redux/feature/Markets/MutualFunds/actions/MutualFundsSchemes";
import MutualFundsHousesActions from "@redux/feature/Markets/MutualFunds/actions/MutualFundsHouses";
export default (function () {
    return {
        mutualFunds: {
            exploreFunds: new ExploreFundsActions(),
            mutualFundsSchemesActions: new MutualFundsSchemesActions(),
            mutualFundsHouseActions: new MutualFundsHousesActions(),
        },
    };
});
